import React, { Children } from 'react';
import { motion } from 'framer-motion';
import { ShieldCheck, Heart, Sparkles, Hand, Sun } from 'lucide-react';
const features = [{
  icon: <ShieldCheck className="w-6 h-6 text-gold" data-id="element-31" />,
  title: 'El Filtro de Alto Valor',
  description: 'Cómo detectar en la primera cita si un hombre tiene la madurez necesaria para estar con una mujer exitosa o si solo es un "vampiro emocional".'
}, {
  icon: <Heart className="w-6 h-6 text-gold" data-id="element-32" />,
  title: 'La Trampa de la Mujer Fuerte',
  description: 'Por qué atraes a hombres inmaduros y cómo romper ese patrón para siempre.'
}, {
  icon: <Sparkles className="w-6 h-6 text-gold" data-id="element-33" />,
  title: 'Compatibilidad vs. Química',
  description: 'Por qué esa "chispa" inicial a veces es tu peor enemiga y qué debes buscar realmente.'
}, {
  icon: <Hand className="w-6 h-6 text-gold" data-id="element-34" />,
  title: 'Límites sin Culpa',
  description: 'Cómo decir que no y alejarte de lo que te quita paz, sin sentir que estás siendo "demasiado exigente".'
}, {
  icon: <Sun className="w-6 h-6 text-gold" data-id="element-35" />,
  title: 'El Descanso Emocional',
  description: 'Cómo permitirte ser cuidada sin perder ni un gramo de tu poder personal.'
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  visible: {
    opacity: 1,
    transition: {
      staggerChildren: 0.2
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  visible: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.6
    }
  }
};
export const Features: React.FC = () => {
  return <section className="py-24 px-6 bg-cream" data-id="element-36">
      <div className="max-w-5xl mx-auto" data-id="element-37">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.8
      }} className="text-center mb-20 max-w-3xl mx-auto" data-id="element-38">
          <p className="text-lg text-charcoal-light mb-6 font-light leading-relaxed" data-id="element-39">
            El problema no es que seas "demasiado". El problema es que hasta
            ahora nadie te había enseñado cómo elegir a un compañero cuando ya
            no necesitas a un salvador.
          </p>
          <p className="text-lg text-charcoal-light mb-10 font-light leading-relaxed" data-id="element-40">
            He escrito este eBook:{' '}
            <strong className="font-serif text-charcoal font-normal text-xl" data-id="element-41">
              “El Hombre Ideal para una Mujer Independiente”
            </strong>
            , pensando exclusivamente en ti. Este no es un libro cursi de "cómo
            encontrar a tu príncipe azul". No hay trucos para perseguir a nadie,
            ni consejos para que te hagas la "difícil".
          </p>
          <div className="flex items-center justify-center space-x-4 mb-8" data-id="element-42">
            <div className="w-12 h-px bg-rose-light" data-id="element-43"></div>
            <h3 className="text-2xl font-serif text-black" data-id="element-44">
              En este eBook descubrirás:
            </h3>
            <div className="w-12 h-px bg-rose-light" data-id="element-45"></div>
          </div>
        </motion.div>

        <motion.div variants={containerVariants} initial="hidden" whileInView="visible" viewport={{
        once: true,
        margin: '-50px'
      }} className="grid grid-cols-1 md:grid-cols-2 gap-8" data-id="element-46">
          {features.map((feature, index) => <motion.div key={index} variants={itemVariants} className={`bg-white p-8 border border-cream-dark shadow-sm hover:shadow-md transition-shadow duration-300 ${index === features.length - 1 ? 'md:col-span-2 md:max-w-xl md:mx-auto' : ''}`} data-id="element-47">
              <div className="w-12 h-12 bg-cream rounded-full flex items-center justify-center mb-6 border border-cream-dark" data-id="element-48">
                {feature.icon}
              </div>
              <h4 className="text-xl font-serif text-black mb-3" data-id="element-49">
                {feature.title}
              </h4>
              <p className="text-charcoal-light font-light leading-relaxed" data-id="element-50">
                {feature.description}
              </p>
            </motion.div>)}
        </motion.div>
      </div>
    </section>;
};